import { Button, Typography } from '@eye-able/ui';
import { useEffect } from 'react';
import { useBootScreen } from '@hooks/useBootScreen';
import { RouterLink } from '@/components/RouterLink';
import { T } from '@/i18n/T';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

export default function NotFoundPage({ is404 = false }: { is404?: boolean }) {
  const { t } = useInlineTranslation();
  const { disableBootScreen } = useBootScreen();

  useEffect(() => {
    disableBootScreen();
  }, [disableBootScreen]);

  return (
    <div className='eye:flex eye:flex-col eye:items-center eye:gap-3xs eye:mt-xl eye:text-center'>
      <Typography tag='h1'>
        {is404 ? '404' : <T k='somethingWentWrong' />}
      </Typography>
      <Typography variant='body-l'>
        {is404 ? <T k='pageNotFound' /> : <T k='notFoundOrNoPermission' />}
      </Typography>
      <Button asChild className='eye:mt-s'>
        <RouterLink to='/'>{t('backToHome')}</RouterLink>
      </Button>
    </div>
  );
}
